import { ChangeDetectionStrategy, Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { WithDestroy } from '../../../shared/components/with-destroy/with-destroy.mixin';
import { ERRORS, PAGES_CONFIG } from '../../../shared/constants/pages.constants';
import { StateProviderService } from '../../../shared/services/state-provider.service';
import { TranslatePipe } from '@ngx-translate/core';

export const ERROR_PAGE_REFRESH_INTERVAL = new InjectionToken('ERROR_PAGE_REFRESH_INTERVAL', {
  factory: () => 10 * 1000
});

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent extends WithDestroy() implements OnInit {
  constructor(
    private stateProviderService: StateProviderService,
    private router: Router,
    private translate: TranslatePipe,
    @Inject(ERROR_PAGE_REFRESH_INTERVAL) private errorPageRefreshInterval: number
  ) {
    super();
  }

  public permission = ERRORS.permission;
  public notFound = ERRORS.notFound;
  public serviceUnavailable = ERRORS.serviceUnavailable;
  public requestsListLink = PAGES_CONFIG.REQUESTS;
  public errorType: string;

  ngOnInit(): void {
    this.errorType = this.stateProviderService.getParam('error');

    if (this.errorType === this.serviceUnavailable) {
      interval(this.errorPageRefreshInterval)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(() => {
          const next: RouterStateSnapshot = this.stateProviderService.getParam('original');
          if (next?.url) {
            this.router.navigate([next.url]);
          } else {
            this.router.navigate(['/']);
          }
        });
    }
  }

  reload(){
    window.location.reload();
  }

  redirect(){
    window.open(this.translate.transform('common.label.service-now-link'), '_blank').focus();
  }
}
